import {DocumentInfoResponseData} from "../../../types/client";
import React, {useEffect, useState} from "react";
import {documentAPI, getDocumentFileAPI} from "../../../services/client";
import {DocumentIcon} from "@heroicons/react/24/outline";
import styles from "./ClientDocumentInfo.module.css";

interface ClientDocumentInfoProps {
    documentId: number;
}

//클라이언트 문서 정보
const ClientDocumentInfo: React.FC<ClientDocumentInfoProps> = ({documentId}) => {
    const [data, setData] = useState<DocumentInfoResponseData | null>(null);
    const [fileUrl, setFileUrl] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    const fetchData = async () => {
        try {
            setLoading(true);
            //클라이언트 문서 조회 API
            const response = await documentAPI(documentId);
            setData(response);
            //클라이언트 문서 첨부파일 조회 API
            const data = await getDocumentFileAPI(documentId);
            //파일 내부 URL 생성
            const url = URL.createObjectURL(data);
            setFileUrl(url);
        } catch (error) {
            console.error('Error fetching document:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [documentId]);

    //날짜 데이터 형식, YYYY-MM-DD(요일)
    const formatDate = (date: Date) => {
        const d = new Date(date);
        return `${d.getFullYear().toString()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} (${['일', '월', '화', '수', '목', '금', '토'][d.getDay()]})`;
    }

    if (loading || !data) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.container}>
            <div className={styles.documentCard}>
                <div className={styles.header}>
                    <div className={styles.headerContent}>
                        <h1 className={styles.title}>
                            {/*문서 제목*/}
                            {data.title}
                            {/*문서 종류*/}
                            <span className={styles.titleType}>{data.documentType}</span>
                        </h1>
                        <div className={styles.dateContainer}>
                            {/*문서 생성일자*/}
                            <span>{formatDate(data.createdAt)}</span>
                        </div>
                    </div>
                </div>

                <div className={styles.content}>
                    <div className={styles.documentText}>
                        {/*문서 내용*/}
                        {data.content}
                    </div>
                </div>

                {/*문서 첨부파일*/}
                {data.fileName && fileUrl && (
                    <div className={styles.fileSection}>
                        {/*다운로드*/}
                        <a href={fileUrl} download={data.fileName} className={styles.fileLink}>
                            <DocumentIcon className={styles.fileIcon}/>
                            <span className={styles.fileName}>{data.fileName}</span>
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
}

export default ClientDocumentInfo;